export const DEBUG_PANEL_VERSION = "v2.4.0";

export interface RouteManifest {
  pages: Record<string, { file: string; layouts: string[] }>;
}

export type DebugTab =
  | "visual"
  | "files"
  | "network"
  | "queries"
  | "session"
  | "i18n"
  | "sse"
  | "renders"
  | "errors"
  | "permissions"
  | "forms"
  | "nav";

export interface DebugSessionContext {
  scope: "central" | "tenant" | "none";
  label: string;
  state: "authenticated" | "anonymous" | "unknown";
}

export interface SafeDebugUser {
  contextKind: "WORKSPACE" | "CENTRAL";
  effectiveNavigationItemIds?: string[];
}

export interface SafeDebugOrganization {
  type?: string;
}

export type TabSource =
  { kind: "file"; path: string } | { kind: "component"; name: string };

export interface SiblingTab {
  label: string;
  isActive: boolean;
  path?: string;
}

export interface ActiveTab {
  label: string;
  source?: TabSource;
  contentSource?: TabSource;
  siblingTabs?: SiblingTab[];
}
